module.exports = __webpack_public_path__ + "static/img/performance_3.893acef8.jpg";